import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-6 col-md-6" }
const _hoisted_3 = { class: "col-lg-6 col-md-6" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-lg-8 col-md-6" }
const _hoisted_6 = { class: "col-lg-4 col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThemeDevelopment = _resolveComponent("ThemeDevelopment")!
  const _component_RecentActivity = _resolveComponent("RecentActivity")!
  const _component_ProjectRoadmapChart = _resolveComponent("ProjectRoadmapChart")!
  const _component_ProjectsOverview = _resolveComponent("ProjectsOverview")!
  const _component_TeamMembers = _resolveComponent("TeamMembers")!
  const _component_ToDoList = _resolveComponent("ToDoList")!
  const _component_TasksOverviewChart = _resolveComponent("TasksOverviewChart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ThemeDevelopment),
        _createVNode(_component_RecentActivity)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ProjectRoadmapChart),
        _createVNode(_component_ProjectsOverview),
        _createVNode(_component_TeamMembers)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ToDoList)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_TasksOverviewChart)
      ])
    ])
  ]))
}